import React, { Component } from "react"
import { Card, CardBody, CardTitle, Row, Col } from "reactstrap"
import { Link } from "react-router-dom"

import ReactApexChart from "react-apexcharts"

class BarChart extends Component {
  constructor(props) {
    super(props)
    this.state = {
      chartData: [],
      orders: true,
      sales: false,
      toggleExpandCountries: false,
      toggleExpandSource: false,
      // salesSources:
    }
    this.displayChartDataCountries = this.displayChartDataCountries.bind(this)
    this.displayChartDataSource = this.displayChartDataSource.bind(this)
  }
  displayChartDataCountries = () => {
    const { groupedDataCountries } = this.props
    const { orders } = this.state
    let country = []
    let dataNC = []
    groupedDataCountries.sort((a, b) => orders ?  b.totalOrdersByCountry - a.totalOrdersByCountry : b.totalSalesByCountry - a.totalSalesByCountry).map((info, key) => { 
      country.push(info["country"])
      dataNC.push(orders ? info["totalOrdersByCountry"]: info["totalSalesByCountry"]) 
    })
    const dataChart = {
      series: [{ name: "New Clients", data: dataNC }],
      options: {
        chart: {
          type: 'bar',
          height: 400
        },
        plotOptions: {
          bar: {
            borderRadius: 4,
            horizontal: true,
          }
        },
        dataLabels: {
          enabled: false,
          // offsetX: -50,
          style: {
            fontSize: '18px',
            colors: ['#fff']
          }
        },
        xaxis: {
          categories: country,
        },
      },
    }
    return dataChart
  }
  displayChartDataSource = () => {
    const { groupedDataSource } = this.props

    let source = []
    let dataNC = []
    groupedDataSource.sort((a, b) => b.totalSalesBySource - a.totalSalesBySource).map((info, key) => { 
      source.push(info["source"])
      dataNC.push(info["totalSalesBySource"]) 
    })
    const dataChart = {
      series: [{ name: "New Clients", data: dataNC }],
      options: {
        chart: {
          type: 'bar',
          height: 400
        },
        plotOptions: {
          bar: {
            borderRadius: 4,
            horizontal: true,
          }
        },
        dataLabels: {
          enabled: false,
          // offsetX: -50,
          style: {
            fontSize: '18px',
            colors: ['#fff']
          }
        },
        xaxis: {
          categories: source,
        },
      },
    }
    return dataChart
  }
  render() {
    const { groupedDataCountries, groupedDataSource } = this.props
    const { orders, toggleExpandCountries, toggleExpandSource } = this.state
    return (
      <React.Fragment>
        <Row>
          <Col sm={12} className={toggleExpandCountries ? 'overlay' : ''}>
            <Card className={toggleExpandCountries ? 'pie-fullscreen' : ''} >
              <CardTitle className='mt-2 h4 align-items-center'>
                <div className='d-flex'>
                  <h4 className="mt-2 ms-3 h4">{orders ? "New Clients by Orders" : "New Clients by Sales"}</h4> 
                  <div className='ms-auto'>
                    <ul className='nav nav-pills'>
                      <li className="nav-item">
                        <Link
                          to="#"
                          className={ orders ? "active nav-link" : "nav-link" }
                          onClick={e => { this.setState({ orders: true, sales: false }) }}
                        >
                          Orders
                        </Link>
                      </li>
                      <li className="nav-item">
                        <Link
                          to="#"
                          className={ !orders ? "active nav-link" : "nav-link" }
                          onClick={e => { this.setState({ orders: false, sales: true }) }}
                        >
                          Sales
                        </Link>
                      </li>
                      <li className='nav-item'>
                        <span className='expand-pie' onClick={() => this.setState({ toggleExpandCountries: !toggleExpandCountries }) } >
                          <i className='bx bx-expand m-2 font-size-22' />
                        </span>
                      </li>
                    </ul>
                  </div>
                </div>
              </CardTitle>
              <CardBody>
                <ReactApexChart
                  series={this.displayChartDataCountries().series}
                  options={this.displayChartDataCountries().options}
                  type="bar"
                  height={groupedDataCountries.length <=5 ? 300 : toggleExpandCountries ? 800 : 500  }
                  className="apex-charts"
                />
              </CardBody>
            </Card>
          </Col>
          <Col sm={12} className={toggleExpandSource ? 'overlay mt-2' : 'mt-2'}>
            <Card className={toggleExpandSource ? 'pie-fullscreen' : ''} >
              <CardTitle className='mt-2 h4 align-items-center'>
                <div className='d-flex'>
                  <h4 className="mt-2 ms-3 h4">New Clients by Source</h4> 
                  <div className='ms-auto'>
                    <ul className='nav nav-pills'>
                      <li className='nav-item'>
                        <span className='expand-pie' onClick={() => this.setState({ toggleExpandSource: !toggleExpandSource }) } >
                          <i className='bx bx-expand m-2 font-size-22' />
                        </span>
                      </li>
                    </ul>
                  </div>
                </div>
              </CardTitle>
              <CardBody>
                <ReactApexChart
                  series={this.displayChartDataSource().series}
                  options={this.displayChartDataSource().options}
                  type="bar"
                  height={groupedDataSource.length <=5 ? 200 : toggleExpandCountries ? 800 : 200  }
                  className="apex-charts"
                />
              </CardBody>
            </Card>
          </Col>
        </Row>
      </React.Fragment>
    )
  }
}
export default BarChart
